export default __webpack_public_path__ + "static/media/diverse-team.4d7dd301.svg";